import { useMemo } from 'react';

import Permissions from '@/common/permissions';
import { useHasAccess } from '@/modules/core/hooks';
import { useRedirectToHome } from '@/modules/core/hooks';
import { useAuthStore } from '@/modules/user/stores';

import { ExpressSetupStatuses } from '../ExpressSetup.types';
import { useCurrentExpressSetup } from '../hooks';

const useLogOutFromExpressSetup = () => {
  const { user } = useAuthStore();
  const { data: expressSetupData, isLoading } = useCurrentExpressSetup();

  const hasAccessToExpressSetup = useHasAccess([{ permission: Permissions.EXPRESS_SETUP }]);
  const hasAbandonedOrDraftStatus = useMemo(() => {
    return expressSetupData?.statusType === ExpressSetupStatuses.ABANDONED
      || expressSetupData?.statusType === ExpressSetupStatuses.DRAFT;
  }, [expressSetupData?.statusType]);

  const isAllowToRedirect = useMemo(() => {
    return (!hasAccessToExpressSetup && !!user) || ((!expressSetupData || !hasAbandonedOrDraftStatus) && !isLoading);
  }, [hasAccessToExpressSetup, expressSetupData, hasAbandonedOrDraftStatus, user, isLoading]);

  const isUserOutdated = useMemo(() => user && user?.expressSetupStatus !== expressSetupData?.statusType,
    [user, expressSetupData]);

  useRedirectToHome(isAllowToRedirect, !!isUserOutdated);
};

export default useLogOutFromExpressSetup;
